import { Typography } from 'antd';
import { FC, memo } from 'react';

import { ProjectDocument } from 'models';
import { useTranslate } from 'hooks';

import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';

export const PrimaryMarketProjectDocuments: FC<{ documents: ProjectDocument[] }> = memo(
	({ documents }) => {
		const { documentsText } = useTranslate(['documentsText']);

		return (
			<div className="primaryItem__block">
				<Typography.Title className="primaryItem__blockTitle" level={4}>
					{documentsText}
				</Typography.Title>

				<div>
					{documents.map((item) => {
						return (
							<a
								key={item.path}
								href={item.path}
								target="_blank"
								rel="noreferrer"
								className="primaryItem__doc"
							>
								<DownloadIcon />
								<Typography.Text>{item.title}</Typography.Text>
							</a>
						);
					})}
				</div>
			</div>
		);
	},
);
